import React from "react";
import { Icon } from "@iconify/react";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import Section from "../Section";
import { pageTitle } from "../../helpers/PageTitle";
import SectionHeading from "../SectionHeading";

const galleryData = [
  { imgUrl: "/images/gallary/optimized/DSC_7757.webp", tag: "Facilities", title: "State-of-the-Art Laboratory", tagColor: "orange", span: 1, alt: "Best fertility clinic in mp" },
  { imgUrl: "/images/gallary/optimized/IMG_3077.webp", tag: "Expertise", title: "Compassionate Care", tagColor: "purple", span: 1, alt: "Best IVF clinic in mp" },
  { imgUrl: "/images/gallary/optimized/gallary.webp", tag: "Joy", title: "Milestones", tagColor: "purple", span: 1, alt: "Fertility specialist in mp" },
  { imgUrl: "/images/gallary/optimized/IMG_3105.webp", tag: "Care", title: "Our Commitment", tagColor: "orange", span: 1, alt: "Best fertility hospital in mp" },
  { imgUrl: "/images/gallary/optimized/gallary1.webp", tag: "Comfort", title: "Relaxed Environment", tagColor: "orange", span: 1, alt: "Best fertility clinic in mp" },
  { imgUrl: "/images/gallary/optimized/gallary2.webp", tag: "Excellence", title: "Clinical Precision", tagColor: "purple", span: 1, alt: "Egg freezing in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7755.webp", tag: "Facilities", title: "Modern Clinic", tagColor: "orange", span: 1, alt: "Best IUI center in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7766.webp", tag: "Environment", title: "Serene Sanctuary", tagColor: "orange", span: 1, alt: "Best IVF doctor in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7819.webp", tag: "Support", title: "Always With You", tagColor: "orange", span: 1, alt: "Best male fertility doctor in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7767.webp", tag: "Technology", title: "Advanced Equipment", tagColor: "purple", span: 1, alt: "Fertility specialist in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_8615.webp", tag: "Care", title: "Patient First", tagColor: "purple", span: 1, alt: "Best laparoscopic surgeon in mp" },
  { imgUrl: "/images/gallary/optimized/DSC_0980.webp", tag: "Technology", title: "Advanced IVF", tagColor: "orange", span: 1, alt: "Best Gynecologist In mp" },
  { imgUrl: "/images/gallary/optimized/DSC_7861.webp", tag: "Expertise", title: "Dedicated Team", tagColor: "purple", span: 1, alt: "Best IVF clinic in mp" },
  { imgUrl: "/images/gallary/optimized/IMG_3076.webp", tag: "Success", title: "Parenthood Joy", tagColor: "orange", span: 1, alt: "Infertility doctor in mp" },
];

export default function Gallery() {
  pageTitle("Gallery");
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/gallery.jpeg"
        imgUrl="/images/about/banner_img.png"
        title="Welcome to <br> Pluro JABALPUR <br/> IVF Gallery"
        subTitle="The special moment of our Pluro Jabalpur IVF Center"
      />

      <section className="cs_mcp_gallery_wrap">
        <div className="cs_mcp_gallery_container">
          <div className="cs_mcp_gallery_header">
            <SectionHeading
              titleUp="HAVE A LOOK AT"
              title="Celebrating Joyful Moments <br />With  Our Happy Patients"
            />
          </div>

          <div className="cs_mcp_gallery_grid">
            { galleryData.map((item, index) => (
              <div
                key={ index }
                className={ `cs_mcp_gallery_card ${item.span === 2 ? "span-2" : ""}` }
              >
                <div className="cs_mcp_gallery_img_wrapper">
                  <img src={ item.imgUrl } alt={ item.alt || "Gallery" } className="cs_mcp_gallery_img" />
                  <span className="cs_mcp_link_hover">
                    <i>
                      <Icon icon="fa6-solid:arrows-up-down-left-right" />
                    </i>
                  </span>
                </div>
              </div>
            )) }
          </div>
        </div>
      </section>
    </>
  );
}
